export default __webpack_public_path__ + "static/052-1b3265a89a55fc3d075fb01c489d8b7a.jpg";